var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('loader',{attrs:{"label":_vm.$t('conflict.searchingTodos')}}):_c('choose-exclusive-and-unique-wigo',{attrs:{"conflict":_vm.conflict},on:{"wigoSelected":function($event){return _vm.prefer($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }